import { useQuery } from "@tanstack/react-query";

import { shellBootstrapQuery } from "./bootstrap";
import { NavigationCards } from "./NavigationCards";
import type { ShellServices } from "./services";
import { EmptyState } from "./states";
import { approvalSectionsNavigation } from "./workspaceNavigation";

/** Вход в раздел «Согласования»: личные задания и шаблоны маршрутов. */
export function ApprovalsOverviewPage({
  services,
}: {
  services: ShellServices;
}) {
  const bootstrap = useQuery(shellBootstrapQuery(services));
  const items =
    bootstrap.data === undefined
      ? []
      : approvalSectionsNavigation(bootstrap.data.permissions);

  return (
    <section
      className="workspace-page"
      aria-labelledby="approvals-overview-title"
    >
      <div className="page-heading">
        <p className="eyebrow">Документооборот</p>
        <h1 id="approvals-overview-title">Согласования</h1>
        <p>Личные задания согласования и шаблоны маршрутов документов.</p>
      </div>
      <NavigationCards items={items} />
      {items.length === 0 ? (
        <EmptyState
          title="Нет доступных разделов"
          description="Для работы с согласованиями нужны дополнительные права."
        />
      ) : null}
    </section>
  );
}
